<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getData">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目:">
          <el-select v-model="listQuery.subject_id" clearable placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考生名称:">
          <el-input v-model="listQuery.name" clearable placeholder="考生名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="exam_name" label="考试名称">
      </el-table-column>
      <el-table-column prop="subject_name" label="考试项目">
      </el-table-column>
      <el-table-column prop="avg_total" label="考试人数">
      </el-table-column>
      <el-table-column prop="avg_score" label="平均成绩">
      </el-table-column>
      <el-table-column prop="avg_time" label="平均用时">
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                student: {},
                examList: [],
                subjectList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20,
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            getData() {
                this.$http.getSubjectScores(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.subjectList = res.subjectDownlist;
                        this.examList = res.examDownlist;
                        this.total = res.meta.total;
                        this.listQuery.exam_id = res.exam_id;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            goDetail(row) {
                this.$router.push({
                    name: 'subjectScoreDetail', query: {
                        subject_id: row.subject_id,
                        exam_id: row.exam_id,
                        subject: row.subject_name,
                        sign: 'subjects'
                    }
                });
            }
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/subjectScores.vue